import { render } from "./MainEng.vue?vue&type=template&id=3db521e6"
import script from "./MainEng.vue?vue&type=script&lang=js"
export * from "./MainEng.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__